import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';

@customElement('webs-card-statistic')
export class CardStatistic extends LitElement {
  static styles = [
    normalizeStyles,
    typographyStyles,
    css`
      .card-statistic h2,p {
        margin-bottom: 0;
      }

      .card-statistic p {
        margin-top: .4rem;
      }

      .light p,
      .light h2 {
        color: var(--color-white);
      }
      `
]

  @property()
  title: string;

  @property()
  description: string;

  @property()
  light: boolean;

  protected render(): unknown {
    return html`
    <div class="card-statistic ${this.light ? 'light':''}">
      ${this.title && this.description? html`
      <h2 class="h1">${this.title}</h2>
      <p>${this.description}</p>
      `:""}
    </div>`
  }
}
